export default "__VITE_ASSET__bd00badd__"